export default __webpack_public_path__ + "static/media/coac-mushuc.6a088aac.jpeg";